import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";import { MdOutlinePictureAsPdf } from "react-icons/md";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; import MasterService from "../../Services/MasterService";
import { IoIosReturnLeft } from "react-icons/io";import Select from 'react-select';

export default function IndicatorTypedistAchievementReport() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [data, setData] = useState([]); const[subTableData,setSubTableData]=useState([]);const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [Yearlist, setYearlist] = useState();const [selectedperiodic, setselectedperiodic] = useState(); const [Periodicitylist, setPeriodicitylist] = useState(); const [searchText, setSearch] = useState("");
 const [SubTableEnb,setSubTableEnb]=useState(false);
 const [SubDistTableEnb,setSubDistTableEnb]=useState(false); const[subDistTableData,setsubDistTableData]=useState([]); const[maintablenb,setmaintablenb]=useState(true); const [searchdistSub,setSearchdistsub]=useState(""); const [selecteddist,setselecteddist]=useState("");
 const [year,setYear] = useState(""); const [yearList,setYearList] = useState([]);
  let username = localStorage.getItem("username"); let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("catid");
  const formik = useFormik({
    initialValues: { year: "", department_id:"", periodic_id:"", district_id:"" ,entrytype:""},
  });
  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);  let params = { userId: username }
          MasterService.getAllDepts(params).then((res) => { if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } }); MasterService.getDistricts().then((res17) => { if (res17.data) { setDistrictList(res17.data); } });
              if(["113","119"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))}
if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); perioicitylist(deptId); }
if(["113","114"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
if(["119"].includes(roleid)){ formik.setFieldValue("district_id",district); }
}, []);


const periodicityMap = {  monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" },half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" }};
const perioicitylist = (dept) => {
  formik.setFieldValue("periodic_id", "");
if (!dept) { setPeriodicitylist([]); return; }

  if (dept === "0") { const allOptions = Object.keys(periodicityMap).map((key) => ({   label: periodicityMap[key].label,  value: periodicityMap[key].value, }));
    setPeriodicitylist(allOptions); return;
  }
const paramss = { userId: username, deptId: dept, };
  KpiService.periodicityStatus(paramss).then((res) => {
    if (res?.data) {
      if (res.data.SCODE === "01") {
        const apiData = res.data.SDESC[0];

        const options = Object.keys(periodicityMap) .filter((key) => apiData[key] > 0) .map((key) => ({ label: periodicityMap[key].label, value: periodicityMap[key].value, }));

        setPeriodicitylist(options);
      } else {
        setPeriodicitylist([]); showAlertMessage(res.data.SDESC, "warning");
      } } }); };


  const YearData = (val) => {
    setData([])
formik.setFieldValue("year","");
    setYearlist([]); 
    if (!val) { return; }
    if(val === "0"){
       MasterService.getfinyears().then((achievvalueres) => {
             if (achievvalueres.data) { setYearList(achievvalueres.data); }
           });
          }
          else{
    let params = { userId: username, periodicityId:val }
    KpiService.KpiperiodicYears(params).then((res20) => {
      let res = res20.data.SDESC.yearsList; if (res20.data) { setYearList(res); }
    }) }
  }
  const getData = (type) => {
    if (!type || !formik.values.department_id || !formik.values.year|| !formik.values.periodic_id) { setSubTableData([]); setData([]); setSubTableEnb(false); return; }
    setselectedperiodic(parseInt(formik.values.periodic_id));
    setYear(formik.values.year); let params = { "year":formik.values.year, "periodicityId":parseInt(formik.values.periodic_id), "deptId":formik.values.department_id, "userId":username, districtId:district, entryType:type };
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.indicatorWiseentryTypeTargetsAchievementsReport(params)
      .then((res) => {
          setSubTableEnb(false);setmaintablenb(false)
       if(type==="hod"){ setmaintablenb(true); setSubDistTableEnb(false); if (res.data && res.data.SCODE == "01") { setData(res.data.SDESC); } else { setData([]); } }
          else{
setmaintablenb(false); setSubDistTableEnb(true);
              if (res.data && res.data.SCODE == "01") {
        const rawData = res.data.SDESC || [];

        const deptName = rawData?.[0]
          ? `${rawData[0].hod_id || ""} - ${rawData[0].dept_name || ""}`.trim()
          : "";

        const nameKey = "district_name";
        const names = [
          ...new Map(
            rawData.map((item) => [
              item.district_code,
              { name: item[nameKey], code: item.district_code, enrty_type: item.enrty_type, },
            ])
          ).values(),
        ];

        const indicatorMap = {};
        rawData.forEach((item) => {
          const indicatorKey = item.indicator_id;

          if (!indicatorMap[indicatorKey]) {
            indicatorMap[indicatorKey] = {
              indicator_id: item.indicator_id, indicator_name: item.indicator_name, unit_name: item.unit_name, periodic_name: item.periodic_name, enrty_type: item.enrty_type, indicator_type: item.indicator_type,
            };
          }const district = item.district_code;

          if (!indicatorMap[indicatorKey][district]) { indicatorMap[indicatorKey][district] = { district_code: item.district_code, district_name: item[nameKey], targets_2025: item.targets_2025, unit_cat_id: item.unit_cat_id, indicator_value_total: item.indicator_value_total, heads: {}, }; }
          const headKey = `${item.head_id}_${item.indicator_id}`;indicatorMap[indicatorKey][district].heads[headKey] = { head_id: item.head_id, head_name: item.head_name, numerator: item.numerator, denominator: item.denominator, indicator_value: item.indicator_value, unit_cat_id: item.unit_cat_id, }; });
 Object.values(indicatorMap).forEach((indicator) => { Object.keys(indicator).forEach((key) => {
    if (typeof indicator[key] !== "object") return; if (indicator[key]?.heads) {
      let headsArr = Object.values(indicator[key].heads); headsArr.sort((a, b) => parseInt(a.head_id) - parseInt(b.head_id));
if (selectedperiodic === 6) { const monthOrder = [6, 7, 8, 9, 10, 11, 12, 13, 14, 3, 4, 5, 0]; headsArr = headsArr.filter( (h) => h.head_id !== null && h.head_id !== undefined && h.head_id !== "" );
  headsArr.sort((a, b) => { const aId = parseInt(a.head_id); const bId = parseInt(b.head_id); if (isNaN(aId) && isNaN(bId)) return 0; if (isNaN(aId)) return 1; if (isNaN(bId)) return -1; const aIndex = monthOrder.indexOf(aId); const bIndex = monthOrder.indexOf(bId); if (aIndex === -1 && bIndex === -1) return 0; if (aIndex === -1) return 1; if (bIndex === -1) return -1; return aIndex - bIndex; });
} else if (selectedperiodic === 5) {
        headsArr = [ ...headsArr.filter((h) => parseInt(h.head_id) >= 1 && parseInt(h.head_id) !== 0),
          ...headsArr.filter((h) => parseInt(h.head_id) === 0), ];
      } else if (selectedperiodic === 7) {
        headsArr = [ ...headsArr.filter((h) => parseInt(h.head_id) >= 15 && parseInt(h.head_id) !== 0),
          ...headsArr.filter((h) => parseInt(h.head_id) === 0), ]; }
      indicator[key].heads = headsArr; } }); });
        const tableData = Object.values(indicatorMap);
        setsubDistTableData({ names, rows: tableData, deptName });
      } else { setsubDistTableData([]); }  }
      }).catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  const filteredData =
    searchText.length > 0 && data?.length  ? data.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) );
        })
      : data;
const filteredSubDistTableData = () => {
  if (!subDistTableData?.rows || !subDistTableData?.names) return { names: [], rows: [] };
  const searchLower = searchdistSub.toLowerCase();
  const filteredNames = subDistTableData.names.filter(({ name }) => name.toLowerCase().includes(searchLower) );
  let filteredRows = subDistTableData.rows;
  if (filteredNames.length === 0 && searchdistSub.trim() !== "") {
    filteredRows = subDistTableData.rows.filter((item) => Object.keys(item).some((key) => { const value = item[key];
        return value !== null && value.toString().toLowerCase().includes(searchLower); }) ); }
  return { names: filteredNames.length > 0 ? filteredNames : subDistTableData.names, rows: filteredRows };
};
const filteredDistDataSub = filteredSubDistTableData();

 const periodHeadOrder = React.useMemo(() => {
  const headMap = new Map();

  filteredDistDataSub?.rows?.forEach((row) => {
    filteredDistDataSub?.names?.forEach(({ code }) => {
      const heads = row?.[code]?.heads || [];

      if (selectedperiodic === 3 && heads.length === 0) {
        headMap.set(`null_${code}`, { id: null, label: "" });
      } else {
        heads.forEach((h) => {
          if (h.head_id !== null && h.head_id !== undefined && h.head_id !== "") {
            headMap.set(parseInt(h.head_id), {
              id: parseInt(h.head_id),
              label: h.head_name || "",
            });
          } else if (selectedperiodic === 3) {
            headMap.set(`null_${code}`, { id: null, label: "" });
          }
        });
      }
    });
  });

  let headsArr = [...headMap.values()];

  if (selectedperiodic === 5) {
    const order = [1, 2, 0];
    headsArr.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
  } else if (selectedperiodic === 7) {
    const order = [15, 16, 17, 18, 0];
    headsArr.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
  } else if (selectedperiodic === 6) {
    // Monthly
    const order = [6,7,8,9,10,11,12,13,14,3,4,5,0];
    headsArr.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
  }

  return headsArr;
}, [filteredDistDataSub, selectedperiodic]);
const hodenb=(id)=>{
  perioicitylist(id)
    formik.setFieldValue("periodic_id",""); formik.setFieldValue("year","");formik.setFieldValue("entrytype","");
    setData([]);
}
 
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white" };

const emptyData=()=>{
  setData([]);
 setSubTableData([]);setSubDistTableEnb(false);setSubTableEnb(false)
setsubDistTableData([]);}

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2> Indicator Wise - Targets , Achievements Hod & <span>  District wise Report </span> </h2> </div> </Container>
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container"> <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}> <div className="py-2 px-4 mb-3"> <Row>
                 <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                                  <label htmlFor="department_id" className="mb-1 fw-bold"> {" "} HOD Name </label> 
                                      <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: ["113","114","115"].includes(roleid), extraOnChange: (option) => { hodenb(option ? option.dept_id : ""); emptyData(); } })} /> </Col>
                 {["113","119"].includes(roleid) &&
                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
                                    <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: true, extraOnChange: (option) => { } })} /> </Col>}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold"> Periodicity </label>
                 <span style={{ color: "red" }}> *</span> 
                  <Select {...commonSelectProps({ name: "periodic_id", options: Periodicitylist, value: formik.values.periodic_id, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false, extraOnChange: (option) => { YearData(option ? option.value : "");formik.setFieldValue("entrytype","");emptyData(); } })} /> </Col>
              <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span>
                          <Select {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => {  } })} /> </Col>
               <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}> <label className="mb-1 fw-bold">Entry Type </label> <span style={{ color: "red" }}> *</span>
  <Select {...commonSelectProps({ name: "entrytype", options: [ { id: "hod", value: "HOD" }, { id: "district", value: "District" } ],
      value: formik.values.entrytype, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false,
      extraOnChange: (option) => { getData(option ? option.id : ""); } })} />
</Col> </Row> </div> </Form> </FormikProvider>

        {maintablenb && <> <Row> <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
              <input type="text" value={searchText}
              placeholder="Search"  onChange={(e) => setSearch(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div> </Col>
          <Col className="mb-2">
           <button className="btn btn-danger btn-sm mx-2 pdf-btn"  style={{ float: "right", marginLeft: "3px" }} onClick={() => generatePdf("#my-table", "indicatorWiseTargetsAchievementsReport", selectedperiodic == 6 ? 21 : selectedperiodic == 7 ? 13 : selectedperiodic == 5 ? 11 : 9)} > PDF <MdOutlinePictureAsPdf /> </button>
           <button size="sm" className="btn mx-2 excel-btn"  onClick={() => exportToExcel("my-table", "indicatorWiseTargetsAchievementsReport")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col> </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style">Hod Indicator Wise- Targets Achievements Value Report</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
       {(() => { let uniqueHeads = [];

  if ([6, 7, 5].includes(selectedperiodic)) { let filterCondition; let defaultHeads = [];
    if (selectedperiodic === 6) { filterCondition = (id) => parseInt(id) >= 1 || parseInt(id) === 0;
      defaultHeads = [ { head_id: 1, head_name: "APR" }, { head_id: 2, head_name: "May" }, ];
    } else if (selectedperiodic === 7) { filterCondition = (id) => parseInt(id) >= 15 || parseInt(id) === 0;
      defaultHeads = [{ head_id: 1, head_name: "Q1 (Apr - Jun)" }];
    } else if (selectedperiodic === 5) { filterCondition = (id) => [1, 2, 0].includes(parseInt(id));
      defaultHeads = [{ head_id: 1, head_name: "HY1" }]; }

    uniqueHeads = [ ...new Map( (filteredData || [])
          .filter((item) => item.head_id && filterCondition(item.head_id))
          .map((item) => [ item.head_id, { head_id: item.head_id, head_name: item.head_name }, ]) ).values(), ];
const monthOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]; const quarterOrder = [15, 16, 17, 18, 0]; const halfYearOrder = [1, 2, 0]; 
    if (selectedperiodic === 6)
      uniqueHeads.sort((a, b) => monthOrder.indexOf(a.head_id) - monthOrder.indexOf(b.head_id));
    else if (selectedperiodic === 7)
      uniqueHeads.sort((a, b) => quarterOrder.indexOf(a.head_id) - quarterOrder.indexOf(b.head_id));
    else if (selectedperiodic === 5)
      uniqueHeads.sort((a, b) => halfYearOrder.indexOf(a.head_id) - halfYearOrder.indexOf(b.head_id));
    const totalHead = uniqueHeads.find((h) => parseInt(h.head_id) === 0);
    uniqueHeads = uniqueHeads.filter((h) => parseInt(h.head_id) !== 0);
    if (totalHead) uniqueHeads.push(totalHead);
    if (uniqueHeads.length === 0) uniqueHeads = defaultHeads;
  }

  return (
    <Table bordered id="my-table" className="custom-table table-responsive  table table-bordered sticky-table">
      <thead>
        <tr className="text-center only-export">
          <th colSpan={8 + ([6, 7, 5].includes(selectedperiodic) ? uniqueHeads.length * 3 : 3)} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }} > Indicator Wise Targets Achievements Report </th>
        </tr>

        <tr className="text-center">
          <th style={headerStyle} className="sticky-col sticky-sno" rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2}> Sl.No. </th>
          <th className="sticky-col sticky-KPIHOD indicator-column" style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2}> HOD Name </th>
          <th style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIIND indicator-column`:""}>
            Indicator Name
          </th>
          <th style={{ ...headerStyle, minWidth: "70px", maxWidth: "70px" }} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvalueUNIT unit-column`:""}>
            Unit
          </th>
          <th style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvaluePERIODIC`:""}>
            Periodicity
          </th>
            <th style={ {...headerStyle, minWidth: "70px", maxWidth: "70px"}} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvalueindtype`:""}>
            Indicator<br/> Type
          </th>
          <th style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvalueNature`:""}>
            Positive / <br/>Negative
          </th>
          <th style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvalueEntry`:""}>
            Entry Level
          </th>
          <th style={headerStyle} rowSpan={["5","6","7"].includes(formik.values.periodic_id) ? 3:2} className={(formik.values.year !=="" && filteredData) ?`sticky-col sticky-KPIvalueTarget`:""}>
            Targets <br /> {formik.values.year}
          </th>
          <th style={headerStyle} colSpan={([6,7,5].includes(selectedperiodic) ? uniqueHeads.length * 3 : 3)}>
            Achievements <br /> {formik.values.year}
          </th>
        </tr>

        {([6,7,5].includes(selectedperiodic)) && (
          <>
            <tr className="text-center">
              {uniqueHeads.map((item) => (
                <th key={item.head_id} style={headerStyle} colSpan={3}>{item.head_name}</th>
              ))}
            </tr>
            <tr className="text-center">
              {uniqueHeads.map((_, idx) => ( <React.Fragment key={idx}> <th style={headerStyle}>Numerator</th> <th style={headerStyle}>Denominator</th> <th style={headerStyle}>Achieved Value</th> </React.Fragment> ))}
            </tr>
          </>
        )}
        {![6,7,5].includes(selectedperiodic) && ( <tr className="text-center"> <th style={headerStyle}>Numerator</th> <th style={headerStyle}>Denominator</th> <th style={headerStyle}>Achieved Value</th> </tr> )}
      </thead>

      <tbody>
        {(!filteredData || filteredData.length === 0) ? (
          <tr>
            <td className="text-center" colSpan={8 + ([6, 7, 5].includes(selectedperiodic) ? uniqueHeads.length * 3 : 3)}>
              <b style={{ color: "red" }}>Details Not Found</b>
            </td>
          </tr>
        ) : (
          (() => {
            let slno = 0;
            const grouped = {};
            filteredData.forEach((item) => { const key = item.dept_id; if (!grouped[key]) grouped[key] = []; grouped[key].push(item); });

            return Object.entries(grouped).flatMap(([deptId, deptRows]) => {
              const groupedIndicators = {};
              deptRows.forEach((item) => {
                if (!groupedIndicators[item.indicator_id]) groupedIndicators[item.indicator_id] = [];
                groupedIndicators[item.indicator_id].push(item);
              });

              const firstDeptRow = deptRows[0];
              const hodCell = ( <td className="sticky-col sticky-KPIHOD indicator-column" style={{ minWidth:(formik.values.year !=="" && filteredData) ?"200px":"", textAlign: "left", verticalAlign: "top", color:  "black", }} rowSpan={Object.keys(groupedIndicators).length} > {firstDeptRow.dept_name || ""} </td> );

              return Object.entries(groupedIndicators).map(([indicatorId, rows], idx) => {slno += 1; const first = rows[0];

                return (
                  <tr key={indicatorId}>
                    <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}>{slno}</td> {idx === 0 && hodCell} <td className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIIND indicator-column`:""} style={{minWidth:(formik.values.year !=="" && filteredData) ?"200px":""}}> {first.indicator_name || ""} </td>
                    <td style={{ minWidth: "70px", maxWidth: "70px", width: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal", textAlign:"left" }} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvalueUNIT`:""} > {first.unit_name || ""} </td>
                    <td style={{ textAlign: "left" }} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvaluePERIODIC`:""}>{first.periodic_name || ""}</td>
                    <td  style={ { minWidth: "70px", maxWidth: "70px",wordBreak:"normal"}} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvalueindtype`:""}>{first.indicator_type || ""}</td>
                    <td style={{ textAlign: "left" }} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvalueNature`:""}>{first.indicator_nature || ""}</td>
                    <td style={{ textAlign: "left" }} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvalueEntry`:""}>{first.enrty_type || ""}</td>
                    <td style={{ textAlign: "right" }} className={(formik.values.year !=="" && filteredData) ? `sticky-col sticky-KPIvalueTarget`:""}>
                      {first.unit_cat_id === 1 ? formatNumberIndianWithDecimal(first.targets_2025) : first.targets_2025}
                    </td>

                    {[6,5,7].includes(selectedperiodic) && uniqueHeads.map(head => {
                      const headData = rows.find(r => r.head_id === head.head_id);
                      console.log("headData",headData);
                      return (
                        <React.Fragment key={head.head_id}>
                          <td style={{ textAlign:"right" }}>{headData?.numerator}</td>
                          <td style={{ textAlign:"right" }}>{headData?.denominator}</td>
                          <td style={{ textAlign:"right" }}>
                            {headData ? (headData.unit_cat_id === 1 ? formatNumberIndianWithDecimal(headData.indicator_value) : headData.indicator_value) : ""}
                          </td>
                        </React.Fragment>
                      );
                    })}

                    {[0,2,3,8].includes(selectedperiodic) && (
                      <>
                        <td style={{ textAlign:"right" }}>{first.numerator}</td>
                        <td style={{ textAlign:"right" }}>{first.denominator}</td>
                        <td style={{ textAlign:"right" }}>
                          {first.unit_cat_id === 1 ? formatNumberIndianWithDecimal(first.indicator_value) : first.indicator_value}
                        </td>
                      </>
                    )}
                  </tr>
                );
              });
            });
          })()
        )}
      </tbody>
    </Table> ); })()} </div> </div> </>}
      
{SubDistTableEnb && 
        <>
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex",
               alignItems: "center", border: "1px solid #ddd", borderRadius: "20px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchdistSub} onChange={(e) => setSearchdistsub(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2"> <button size="sm" 
            className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} 
            onClick={() => exportToExcel("my-table1", "indicatorWiseTargetsAchievementsReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
           </Col> </Row>

         <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }}
          className="rounded-1 border py-1"> <span className="style"> District  Indicator Wise  Targets Achievements Value Report</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
     
<Table
  id="my-table1"
  className="custom-table table-responsive table-bordered sticky-table"
>
  <thead>
    {/* ========== ROW 1 : PERIODS ========== */}
    <tr>
      <th rowSpan={3} className="sticky-col sticky-sno" style={headerStyle}>
        Sl.No
      </th>
      <th
        rowSpan={3}
        style={headerStyle}
        className="sticky-col sticky-KPIHOD indicator-column"
      >
        Indicator Name
      </th>
      <th
        rowSpan={3}
        style={{ ...headerStyle, minWidth: "70px", maxWidth: "70px" }}
        className="sticky-col sticky-KPIUnit unit-column"
      >
        Unit
      </th>
      <th
        rowSpan={3}
        style={headerStyle}
        className="sticky-col sticky-KPIPeriodicity"
      >
        Periodicity
      </th>
      <th
        rowSpan={3}
        style={{ ...headerStyle, minWidth: "85px", maxWidth: "85px" }}
        className="sticky-col sticky-KPIindtype"
      >
        Indicator<br/> Type
      </th>
      <th rowSpan={3} style={headerStyle} className="sticky-col sticky-KPIENTRY">
        Entry Level
      </th>

      {periodHeadOrder.map((p) => (
        <th
          key={p.id}
          colSpan={filteredDistDataSub.names.length * 4} // Target + Numerator + Denominator + Achieved
          style={headerStyle}
        >
          {p.label}
        </th>
      ))}
    </tr>

    {/* ========== ROW 2 : DISTRICTS ========== */}
    <tr>
      {periodHeadOrder.map((p) =>
        filteredDistDataSub.names.map(({ name, code }) => (
          <th key={`${p.id}_${code}`} colSpan={4} style={headerStyle}>
            {name}
          </th>
        ))
      )}
    </tr>

    {/* ========== ROW 3 : Target + NDA ========== */}
    <tr>
      {periodHeadOrder.map((p) =>
        filteredDistDataSub.names.map(({ code }) => (
          <React.Fragment key={`${p.id}_${code}_nda`}>
            <th style={headerStyle}>Target ({formik.values.year})</th>
            <th style={headerStyle}>Numerator</th>
            <th style={headerStyle}>Denominator</th>
            <th style={headerStyle}>Achieved Value</th>
          </React.Fragment>
        ))
      )}
    </tr>
  </thead>

  <tbody>
    {filteredDistDataSub?.rows?.length > 0 ? (
      filteredDistDataSub.rows.map((row, idx) => (
        <tr key={row.indicator_id}>
          {/* ===== FIXED COLUMNS ===== */}
          <td className="sticky-col sticky-sno" style={{textAlign:"center"}}>{idx + 1}</td>
          <td className="sticky-col sticky-KPIHOD indicator-column">
            {row.indicator_name}
          </td>
          <td className="sticky-col sticky-KPIUnit unit-column">{row.unit_name}</td>
          <td className="sticky-col sticky-KPIPeriodicity">{row.periodic_name}</td>
          <td className="sticky-col sticky-KPIindtype" style={{ minWidth: "85px", maxWidth: "85px",wordBreak:"break-word" }}>{row.indicator_type}</td>
          <td className="sticky-col sticky-KPIENTRY">{row.enrty_type}</td>

          {/* ===== PERIOD → DISTRICT → Target + NDA ===== */}
          {periodHeadOrder.map((p) =>
            filteredDistDataSub.names.map(({ code }) => {
              const district = row[code] || {};
              const head =
                district.heads?.find((h) => parseInt(h.head_id) === p.id) || {};

              // Correct target value: fallback to district-level if head is missing
              const targets =
                head?.unit_cat_id === 1
                  ? formatNumberIndianWithDecimal(
                      head?.targets_2025 ?? district?.targets_2025
                    )
                  : head?.targets_2025 ?? district?.targets_2025 ?? "";

              return (
                <React.Fragment key={`${row.indicator_id}_${p.id}_${code}`}>
                  <td style={{textAlign:"right"}}>{targets}</td>
                  <td style={{textAlign:"right"}}>{head.numerator ?? ""}</td>
                  <td style={{textAlign:"right"}}>{head.denominator ?? ""}</td>
                  <td style={{textAlign:"right"}}>
                    {head.unit_cat_id === 1
                      ? [0, 0.0, null].includes(head.indicator_value)
                        ? 0
                        : formatNumberIndianWithDecimal(head.indicator_value)
                      : head.indicator_value ?? ""}
                  </td>
                </React.Fragment>
              );
            })
          )}
        </tr>
      ))
    ) : (
      <tr>
        <td
          colSpan={6 + periodHeadOrder.length * filteredDistDataSub.names.length * 4}
          style={{ textAlign: "center", color: "red" }}
        >
          No data found
        </td>
      </tr>
    )}
  </tbody>
</Table>

          </div>
        </div>            
        </>}

     
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
